var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8199,
    cy: 4.86186,
    r: 0.572043,
    stroke: "#33363F",
    strokeWidth: 1.14409,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49985 11.1525H3.4903C2.94863 11.1525 2.62036 10.5545 2.91117 10.0975L5.66498 5.77006C5.93472 5.34618 6.5535 5.34618 6.82324 5.77006L8.2937 8.08078L9.10664 6.86137C9.37835 6.4538 9.97725 6.4538 10.249 6.86137L12.3986 10.0858C12.7027 10.542 12.3757 11.153 11.8274 11.153H7.52819C7.51867 11.153 7.50923 11.1528 7.49985 11.1525Z",
    fill: "#7E869E",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.54f7a15279c1953dab8ed005df092942.svg";
export { ForwardRef as ReactComponent };